module.exports = __webpack_public_path__ + "08307b62394c3bbf0679d6a3cf9367c1.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/tea.png
 ** module id = 1576
 ** module chunks = 0
 **/